{
  "valid": "Валиден"
}
